import { ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  useMediaQuery,
  useTheme
} from "@mui/material";
import {
  MRT_EditActionButtons as MRTEditActionButtons,
  MRT_Row,
  MRT_TableInstance
} from "material-react-table";
import { RoomlayoutServiceRow } from "./Domain/Types/FacilityService-Roomlayout-row.types";
import { TransitionForSlideoutPanel } from "../../SlideoutPanel/SlideoutPanelTransition.component";

export function SlidePanelCreateEditService({
  table,
  row,
  internalEditComponents,
  headline
}: Readonly<{
  table: MRT_TableInstance<RoomlayoutServiceRow>;
  row: MRT_Row<RoomlayoutServiceRow>;
  internalEditComponents: ReactNode[];
  headline: string;
}>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const createOrEditDialogStyle = {
    height: "calc(-64px + 100vh)",
    maxHeight: "calc(-64px + 100vh)",
    maxWidth: isMobile ? "inherit" : "50vw",
    position: "absolute",
    right: 0,
    margin: 0,
    width: isMobile ? "100%" : "40vw",
    padding: 3,
    top: "64px"
  };

  return (
    <Dialog
      open
      data-testid="roomlayout_edit_row_dialog"
      slotProps={{ paper: { sx: { ...createOrEditDialogStyle } } }}
      transitionDuration={400}
      slots={{ transition: TransitionForSlideoutPanel }}
    >
      {/* edit room layout dialog contents */}
      <DialogTitle variant="h4">{headline}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", mt: 2 }}>
        <Grid2 container data-testid="edit-roomlayout-dialog-contents" columnGap={4}>
          <Grid2 container size={{ xs: 12 }} rowGap={3.5}>
            {/* image */}
            {internalEditComponents[1]}
            {/* name */}
            {internalEditComponents[2]}
            {/* description */}
            {internalEditComponents[3]}
            {/* layout */}
            {internalEditComponents[0]}
          </Grid2>
        </Grid2>
      </DialogContent>

      <Divider sx={{ mt: 3, mb: 3, opacity: "0.6" }} />
      <DialogActions>
        <MRTEditActionButtons variant="text" table={table} row={row} />
      </DialogActions>
    </Dialog>
  );
}
